import { useEffect, useState } from 'react';
import {
  Button,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerHeaderTitle,
  Field,
  Input,
  OverlayDrawer,
  Spinner,
  Text
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { MessageBarType } from '@fluentui/react';
import { MessageComponent } from '../../../commons/component/MessageComponent';
import { connector, Props, useStyles } from './SedesForm.Functions';
import './SedesForm.Styles.css';

const SedesFormComponent = ({ isOpen, onClose, isSaving, isSaved, failOnSaving, error, CreateSede }: Props) => {
  const styles = useStyles();

  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [validationErrors, setValidationErrors] = useState<string[]>([]);

  const resetForm = () => {
    setName('');
    setAddress('');
    setSubmitted(false);
    setValidationErrors([]);
  };

  useEffect(() => {
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isSaved && submitted) {
      resetForm();
      onClose();
    }
  }, [isSaved, submitted, onClose]);

  const validate = (): boolean => {
    const errors: string[] = [];
    if (!name.trim()) {
      errors.push('Debe ingresar un nombre para la sede');
    }
    setValidationErrors(errors);
    return errors.length === 0;
  };

  const handleSubmit = () => {
    setSubmitted(true);
    if (!validate()) {
      return;
    }

    CreateSede({
      name: name.trim(),
      direccion: address.trim() || null
    });
  };

  const handleCancel = () => {
    resetForm();
    onClose();
  };

  return (
    <OverlayDrawer position="end" open={isOpen}>
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              aria-label="Close"
              icon={<Dismiss24Regular />}
              onClick={handleCancel}
              disabled={isSaving}
            />
          }
        >
          Crear Sede
        </DrawerHeaderTitle>
      </DrawerHeader>

      <DrawerBody className="sedes-form-body">
        <div className={styles.container}>
          {validationErrors.length > 0 && (
            <MessageComponent
              message="Verifique la información suministrada"
              type={MessageBarType.error}
              itemList={validationErrors}
            />
          )}
          {failOnSaving === true && (
            <MessageComponent
              message={error?.ErrorMessage || 'Ocurrio un error inesperado'}
              type={MessageBarType.error}
              itemList={error?.Errors}
            />
          )}
          <Field label="Nombre" required>
            <Input
              value={name}
              onChange={(e) => setName(e.currentTarget.value)}
              placeholder="Nombre de la sede"
            />
          </Field>
          <Field label="Dirección">
            <Input
              value={address}
              onChange={(e) => setAddress(e.currentTarget.value)}
              placeholder="Dirección (opcional)"
            />
          </Field>
        </div>
      </DrawerBody>

      <DrawerFooter>
        <div className={styles.actions}>
          <Button onClick={handleCancel} disabled={isSaving}>Cancelar</Button>
          <Button appearance="primary" onClick={handleSubmit} disabled={isSaving}>
            {isSaving && <><Spinner size="extra-tiny" /> <Text>Guardando</Text></>}
            {!isSaving && 'Guardar'}
          </Button>
        </div>
      </DrawerFooter>
    </OverlayDrawer>
  );
};

export default connector(SedesFormComponent as any);
